"use strict";

var AjaxFiles = function () {

  var handleAjaxFiles = function (form, layer, controller, action, api_listing) {
    var data = $(form).serializeArray();
    data.push({ name: 'upaction', value: 'async' });
    data.push({ name: 'controller', value: controller });
    data.push({ name: 'action', value: action });
    data.push({ name: 'api_listing', value: api_listing });

    $.ajax({
      url: URL,
      type:'POST',
      data: data,
      beforeSend: function(){
        $("#page-spinner-loading").show();
      },
      complete: function(){
        $("#page-spinner-loading").hide();
      },
      success: function(data) {
        if (layer) {
          $(layer).html(data);
          Tooltips.init();
        }
      },
      error: function(exception){
        console.log('Exeption:' + JSON.stringify(exception));
      }
    });
  };

  return {
    init: function(form, layer, controller, action, api_listing) {
      handleAjaxFiles(form, layer, controller, action, api_listing);
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = AjaxFiles;
}